import { AppRoutes } from 'routes';
import { isKiosk, isTouchDevice } from './platform';
import { getRange } from './queryUtils';

/**
 * Print should not be visible on PLATSA touch kiosks
 * Print should only be visible on summary page
 * Print should be visible if allowPrint is set to true
 * Print shall never be visible if allowPrint is set to false
 */
export const checkIfPrintShallBeEnabled = (
  allowPrintOverride: string | null,
  locationPathName: any
): boolean => {
  if (locationPathName !== AppRoutes.SUMMARY) {
    return false;
  }

  switch (allowPrintOverride) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      if (isKiosk() && getRange() === 'platsa' && isTouchDevice()) {
        return false;
      }
  }

  return true;
};
